"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from "@/components/ui/command";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

import ProfileDropdown from "./ProfileDropdown";
import useHeader from "@/hooks/useHeader";
import { Logo } from "image-config";
import CustomImage from "./custom-image/custom-image";

function Header({ title }: Readonly<{ title?: string }>) {
  const { pathTitle, locale, switchLanguage, open, setOpen, runCommand } =
    useHeader();
  const pathname = usePathname();
  const isAuthPage = pathname?.startsWith("/login") || pathname?.startsWith("/restore") || pathname?.startsWith("/reset");

  return (
    <header className="shadow-sm flex justify-between items-center bg-primary sticky top-0 z-50">
      <div className="py-4 px-5 flex items-center gap-3">
        {isAuthPage && (
          <Link href="/" className="flex items-center shrink-0">
         
            <CustomImage
              src={Logo}
              alt="Logo"
              width={50}
              height={50}
              className="object-contain"
            />
          </Link>
        )}
       
      </div>
      {!isAuthPage && (
        <div className="flex items-center justify-end py-4 px-4">
          <ProfileDropdown />
        </div>
      )}
      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput
          className="border-[#e0e0e0] min-w-[300px]"
          placeholder="Type a command or search..."
        />
        <CommandList>
          <CommandEmpty>No results found.</CommandEmpty>
          <CommandList>
            <CommandEmpty>No results found.</CommandEmpty>
            <CommandGroup heading="Pages">
              <CommandItem onSelect={() => runCommand("/dashboard")}>
                Dashboard
              </CommandItem>
              <CommandItem onSelect={() => runCommand("/settings")}>
                Settings
              </CommandItem>
            </CommandGroup>
            {/* Add more command groups or items as needed */}
          </CommandList>
          {/* Add your search results or commands here */}
        </CommandList>
      </CommandDialog>
    </header>
  );
}

export default Header;
